import type { JSX } from 'react';

// EW-190: shown when the IdP round trip itself failed, instead of starting another login.
// Redirecting again would bounce the browser between the app and the IdP without ever
// rendering anything. Lives outside MsalProvider (main.tsx renders it standalone), so it
// must not touch MSAL hooks — a reload restarts the flow.
export function AuthErrorScreen({ message }: { message: string }): JSX.Element {
  return (
    <div className="flex h-screen items-center justify-center bg-background p-6">
      <div className="card w-full max-w-md bg-card p-8 text-center">
        <h1 className="text-lg font-medium text-heading">A bejelentkezés nem sikerült</h1>
        <p className="mt-2 break-words text-sm text-muted-foreground">{message}</p>
        <button className="btn-primary mt-6" onClick={() => window.location.reload()}>
          Újra
        </button>
      </div>
    </div>
  );
}
